import * as yup from 'yup';

export const orgUnitSchema = yup.object().shape({
    name: yup.string().required('Requis'),
    tenant: yup.object().nullable().required('Requis'),
});